import { template } from "@ember/template-compiler";
import { assert } from '@ember/debug';
import { isDevelopingApp, macroCondition } from '@embroider/macros';
import type { TOC } from '@ember/component/template-only';
export const TARGETS = Object.freeze({
    popover: 'ember-primitives__portal-targets__popover',
    tooltip: 'ember-primitives__portal-targets__tooltip',
    modal: 'ember-primitives__portal-targets__modal'
});
export function findNearestTarget(origin1: Element, name1: string) {
    assert(`first argument to \`findNearestTarget\` must be an element`, origin1 instanceof Element);
    assert(`second argument to \`findNearestTarget\` must be a string`, typeof name1 === `string`);
    let element1: Element | null = null;
    let parent1 = origin1.parentNode;
    while(!element1 && parent1){
        element1 = parent1.querySelector(`[data-portal-name=${name1}]`);
        if (element1) break;
        parent1 = parent1.parentNode;
    }
    if (macroCondition(isDevelopingApp())) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).prime0 = origin1;
    }
    assert(`Could not find element by the given name: \`${name1}\`.` + ` The known names are ` + `${Object.values(TARGETS).join(', ')} ` + `-- but any name will work as long as it is set to the \`data-portal-name\` attribute. ` + `Double check that the element you're wanting to portal to is rendered. ` + `The element passed to \`findNearestTarget\` is stored on \`window.prime0\` ` + `You can debug in your browser's console via ` + `\`document.querySelector('[data-portal-name="${name1}"]')\``, element1);
    return element1;
}
export interface Signature {
    Args: {
    };
    Blocks: {
    };
}
export const PortalTargets: TOC<Signature> = template(`
  <div data-portal-name={{TARGETS.popover}}></div>
  <div data-portal-name={{TARGETS.tooltip}}></div>
  <div data-portal-name={{TARGETS.modal}}></div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default PortalTargets;
